jQuery(() => {

  const apiUrl = window.location.href.indexOf('localhost') > -1 ? 'http://localhost:8061/api' : 'https://apps.blkboxfitness.com/fp/api';
  const editorPage = 'https://www.blkboxfitness.com/pages/gym-designer-builder';

  const getCustomerId = () => {
    try {
      let curr = window.ShopifyAnalytics.meta.page.customerId;
      if (curr !== undefined && curr !== null && curr !== '') {
        return curr;
      }
    } catch(e) { }
    try {
      let curr = window.meta.page.customerId;
      if (curr !== undefined && curr !== null && curr !== '') {
        return curr;
      }
    } catch (e) { }
    try {
      let curr = _st.cid;
      if (curr !== undefined && curr !== null && curr !== '') {
        return curr;
      }
    } catch (e) { }
    try {
      let curr = ShopifyAnalytics.lib.user().traits().uniqToken;
      if (curr !== undefined && curr !== null && curr !== '') {
        return curr;
      }
    } catch (e) { }
    return null;
  };

  const logError = (friendlyError, err) => {
    console.log(friendlyError);
  };

  const id = getCustomerId() || 0;

  const getProjects = ($myGyms, $saveNone, id) => {
    jQuery.ajax({
      type: 'GET',
      url: `${apiUrl}/project/list.php?cid=${id}`,
      dataType: 'json',
      async: false,
      success: ({ projects }) => {
        $myGyms.html(projects.map((g) => `<div class='gym-designer-main-inner-options-gyms-item'>
            <a href='${editorPage}?id=${g.id}' class='open' data-id='${g.id}'><img src='${g.thumbnail}' alt='${g.name}' data-id='${g.id}' /></a>
            <a href='${editorPage}?id=${g.id}' class='gym-designer-main-inner-options-gyms-item-title open' data-id='${g.id}'>${g.name}</a>
            <a href='#' class='gym-designer-main-inner-options-gyms-item-delete' data-id='${g.id}'>Delete this gym</a>
          </div>`));
        $saveNone.toggle(!projects || projects.length === 0);
        $myGyms.toggle(projects && projects.length > 0);
      },
      error: (err) => {
        logError('Invalid request', err);
      }
    });
  };

  const newProject = (id, name) => {
    $.ajax({
      type: 'POST',
      url: `${apiUrl}/project/new.php?cid=${id}&name=${encodeURIComponent(name)}`,
      dataType: 'json',
      async: false,
      success: ({ id, success }) => {
        if (success === true) {
          window.open(`${editorPage}?id=${id}`);
        }
      },
      error: (err) => {
        logError('Could not create new project', err);
      }
    });
  };

  const deleteProject = (id, projectId, $element) => {
    $.ajax({
      type: 'GET',
      url: `${apiUrl}/project/delete.php?cid=${id}&pid=${projectId}`,
      dataType: 'json',
      async: false,
      success: ({ success }) => {
        if (success === true) {
          $element.remove();
        }
      },
      error: (err) => {
        logError('Could not delete project', err);
      }
    });
  };


  const openProject = (id, projectId) => {
    $.ajax({
      type: 'GET',
      url: `${apiUrl}/project/open.php?cid=${id}&pid=${projectId}`,
      dataType: 'json',
      async: false,
      success: ({ success }) => {
        if (success === true) {
          window.open(`${editorPage}?id=${projectId}`);
        }
      },
      error: (err) => {
        logError('Could not delete project', err);
      }
    });
  };

  // cached jQuery selectors for performance reasons
  const $myGyms = $('.gym-designer-main-inner-options-gyms');
  const $newGym = $('#gym-designer-new');
  const $saveClose = $('.new-gym-modal-inner-close');
  const $saveCreate = $('button', '.new-gym-modal-inner');
  const $saveName = $('input', '.new-gym-modal-inner');
  const $newGymModal = $('.new-gym-modal');
  const $saveNone = $('.gym-designer-main-inner-options-gyms-none');

  $newGym.on('click', (event) => {
    event.preventDefault();
    $newGymModal.toggle(true);
  });

  $('.gym-designer-main-inner-options-gyms').on('click', '.gym-designer-main-inner-options-gyms-item-delete', (event) => {
    event.preventDefault();
    const projectId = $(event.target).data('id');
    deleteProject(id, projectId, $(event.target).parent());
  });

  $('.gym-designer-main-inner-options-gyms').on('click', '.gym-designer-main-inner-options-gyms-item a.open', (event) => {
    event.preventDefault();
    const projectId = $(event.target).data('id');
    openProject(id, projectId);
  });

  $saveClose.on('click', (event) => {
    event.preventDefault();
    $newGymModal.toggle(false);
  });

  $saveCreate.on('click', (event) => {
    event.preventDefault();
    newProject(id, $saveName.val());
  });

  getProjects($myGyms, $saveNone, id);

});